// extracted by mini-css-extract-plugin
module.exports = {"FourOhFour":"FourOhFour_FourOhFour__KMLvF"};